import { types } from "../../types/types"
import { startAlerta } from "../ui/alertas";
import { handleErrorApi } from "../../helpers/randoms";
import { finishSpinner, startSpinner } from "../ui/spinner";
import DiscapacidadService from "../../services/DiscapacidadService";
import { cambiarEstadoSolicitudDiscapacidad } from "../discapacidad/discapacidadActions";
import { ESTADO_SOLICITUD_INTEGRACION } from "../../components/Discapacidad/data/constants";

export const changeStepDiscapacidadAutoG = (step) => async (dispatch) => {
  dispatch({
      type: types.changeStepperDiscapacidadAfiliado,
      payload: step
  })
}

export const clearReducerDiscapacidadAutoG = () => ({ type: types.discapacidadClearReducerAutoG });

export const startLoadingDiscapacidadAutoG = () => ({ type: types.discapacidadSolicitudesAutoGStartLoading });

export const finishLoadingDiscapacidadAutoG = () => ({ type: types.discapacidadSolicitudesAutoGFinishLoading });

export const setSolicitudDiscapacidadAutoG = (solicitud) => {
  return {
    type: types.discapacidadSetSolicitudAutoGSeleccionada,
    payload: solicitud,
  };
};

export const updateSolicitudDiscapacidadAutoG = (key, value) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().afiliadoDiscapacidad;

    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada };
      solicitudAux[key] = value;
      dispatch({
        type: types.discapacidadSetSolicitudAutoGSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const updateSolicitudDiscapacidadAutoGValues = (values) => {
  return (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().afiliadoDiscapacidad;
    if (solicitudSeleccionada) {
      const solicitudAux = { ...solicitudSeleccionada, ...values };
      dispatch({
        type: types.discapacidadSetSolicitudAutoGSeleccionada,
        payload: solicitudAux,
      });
    }
  };
};

export const updateSolicitudDiscapacidadAutoGTransporte = (key, value) => {
  return async (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().afiliadoDiscapacidad;
    
    if (solicitudSeleccionada?.integracionTransporte) {
      const newTransporte = solicitudSeleccionada?.integracionTransporte;
      newTransporte[key] = value;
      
      dispatch({
        type: types.discapacidadUpdateTransporteSolicitudAutoGSeleccionada,
        payload: newTransporte,
      });
    }
  };
};

export const updateSolicitudDiscapacidadAutoGTerapia = (key, value) => {
  return async (dispatch, getState) => {
    const { solicitudSeleccionada } = getState().afiliadoDiscapacidad;
    
    if (solicitudSeleccionada?.integracionTerapia) {
      const newTerapia = solicitudSeleccionada?.integracionTerapia;
      newTerapia[key] = value;
      
      dispatch({
        type: types.discapacidadUpdateTerapiaSolicitudAutoGSeleccionada,
        payload: newTerapia,
      });
    }
  };
};

export const getSolicitudesDiscapacidadAutoG = (
  idAfiliado,
  idEstadoSolicitud
) => {
  return async (dispatch) => {
    try {
      dispatch(startLoadingDiscapacidadAutoG());
      const result = await DiscapacidadService.getMisSolicitudesDiscapacidad(
        idAfiliado,
        idEstadoSolicitud
      );
      const body = await result.json();
      if (result.ok) {
        dispatch({
          type: types.discapacidadGetSolicitudesAutoGSuccess,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishLoadingDiscapacidadAutoG());
    } catch (error) {
      dispatch(finishLoadingDiscapacidadAutoG());
      dispatch({ type: types.discapacidadGetSolicitudesAutoGError });
      handleErrorApi(
        dispatch,
        error,
        "Error al obtener las solicitudes",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};

export const postSolicitudDiscapacidadAutoG = (
  data,
  nextStep = null,
  setRedirect = null,
  modificarEstado = null
) => {
  return async (dispatch) => {    
    try {
      dispatch(startSpinner());
      const result = !!data?.idSolicitud
        ? await DiscapacidadService.putSolicitud(data)
        : await DiscapacidadService.postSolicitud(data);
      const body = await result.json();
      if (result.ok) {
        dispatch(
          startAlerta(
            !!data?.idSolicitud
              ? "Solicitud actualizada correctamente"
              : "Solicitud enviada correctamente",
            "success",
            "Comando Exitoso"
          )
        );
        if (!data.idSolicitud){
          dispatch(updateSolicitudDiscapacidadAutoG("idSolicitud", body.idSolicitud));
        }
        if (nextStep) dispatch(changeStepDiscapacidadAutoG(nextStep));
        if(modificarEstado)
          dispatch( cambiarEstadoSolicitudDiscapacidad(
            {
              esAfiliado: true,
              idSolicitud: data.idSolicitud, 
              idEstadoSolicitud: ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA
            }, 
            setRedirect
            ) 
          );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.autorizacionesGetSolicitudesError });
      handleErrorApi(
        dispatch,
        error,
        !!data?.idSolicitud
          ? "Error al actualizar solicitud"
          : "Error al enviar la solicitud",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
};
